module.exports = __webpack_public_path__ + "d64c92928ea8a4052176b01827ea8750.pdf";